module.exports = __webpack_public_path__ + "img/existing-resources-1-1.88102e40.jpg";